// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2vCQJ","left":"styles_left__Ie3c7","desktopActions":"styles_desktopActions__3l-RQ","title":"styles_title__1oCps"};